import { useEffect } from 'react'
import { UseFormReturn } from 'react-hook-form'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'

type ValidationsProps = {
  formMethods: UseFormReturn<CustomFormQuestion>
}

export default function useUnregisterDefaultValueField({ formMethods }: ValidationsProps) {
  useEffect(() => {
    return () => {
      formMethods.unregister('default_value')
      formMethods.setValue('default_value', '')
    }
  }, [])

  return null
}
